import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
    firstRoute: {},
	currentRoute: {},
	sidebar: false,
	showLoading: true,
	loading: [],
	params: {},
	layout: {
		type: 'user'
	}
}

export const commonSlice = createSlice({
	name: 'base/common',
	initialState,
	reducers: {
        setFirstRoute: (state, action) => {
            state.firstRoute = action.payload
        },
        setCurrentRoute: (state, action) => {
            state.currentRoute = action.payload
        },
        setParams: (state, action) => {
            state.params = action.payload
        },
        setCurrentRouteExtras: (state, action) => {
            state.currentRoute = {...state.currentRoute, extraKey: action.payload}
        },
        setSidebar: (state, action) => {
            state.sidebar = action.payload
        },
		addLoading: (state, action) => {
			state.loading = [...state.loading, action.payload]
		},
		removeLoading: (state, action) => {
			let loading = [...state.loading]
			loading.splice(loading.indexOf(action.payload), 1)
			state.loading = [...loading]
		},

		setLayout: (state, action) => {
			state.layout = {
				...state.layout,
				...{type: action.payload}
			}
		},
		setPreviousLayout: (state, action) => {
			state.layout.previousType = action.payload
		},
	},
})

export const { setCurrentRoute, setCurrentRouteExtras, setSidebar, setLayout, setPreviousLayout, addLoading, removeLoading, setFirstRoute, setParams } = commonSlice.actions

export default commonSlice.reducer
